import { useQuery } from "@tanstack/react-query";
import { client } from "@/api/client";
import { handleError } from "@/api/error";

export const useValidateInvite = (token: string) => {
  return useQuery({
    queryKey: ["validate-invite", token],
    queryFn: async () => {
      const res = await client.invitations.$get({ query: { token } });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};
